import React from "react";
import { useSelector } from "react-redux";
import { selectNavHeight } from "../../redux/navbar/navHeightSlice";

const NavHeightAdjust = ({ children, className = "" }) => {
  const navHeight = useSelector(selectNavHeight);

  return (
    <div
      className={`mx-auto w-full ${className}`}
      style={{
        marginTop: navHeight,
        height: `calc(100vh - ${navHeight}px)`,
        overflow: "auto",
      }}
    >
      {children}
    </div>
  );
};

export default NavHeightAdjust;
